// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__8FqeH","button-loading":"style_button-loading__Kc9MM"};